import React, { Component } from 'react';
import { DownloadButton } from '@eg/elements/DownloadButton';
import { Button } from "@eg/elements/Button";
import "./Download.scss";

import axios from 'axios';

class WithdrawalDownload extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    var hash = this.getUrlData(2);

    axios.get(process.env.REACT_APP_BACKEND_URL +'/csppolicies/'+ hash + '/resignate', {responseType: 'blob'}).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));

      if(window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(response.data, 'Aufhebungsbestätigung.pdf');
      } else {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Aufhebungsbestätigung.pdf');
        document.body.appendChild(link);
        link.click();
      }
    }).catch((error) => {
      this.errorHandler(error);
    });
  }

  errorHandler = (error) => {
    if(error.response === undefined) {
      this.props.history.push("/internet-schutzbrief/404");
    } else if(error.response.status === 500) {
      this.props.history.push("/internet-schutzbrief/anfrage-fehlgeschlagen");
    } else if(error.response.status === 405 ) {
      this.props.history.push("/internet-schutzbrief/anfrage-fehlgeschlagen");
    } else if(error.response.status === 404) {
      this.props.history.push("/internet-schutzbrief/404");
    } else {
      this.props.history.push("/internet-schutzbrief/404");
    }
  }

  getUrlData = (part) => {
    var url =  window.location.pathname.split('/');
    return url[part];
  }

  render() {
    return (
      <div className="outerContainer">
        <div className="esc_container outerContainer" id="download-container">
          <div className="esc_container esc_container--l">
            <hr />
            <h2>Laden Sie hier Ihre Bestätigung zur Vertragsaufhebung herunter:</h2>
            <p>
              Bitte klicken Sie zum einmaligen Download Ihrer Aufhebungsbestätigung auf den „Download”-Button.
            </p>
            <DownloadButton id="policyDownloadButton" onClick={this.handleClick} fileSize="0,4 MB">Ihre Aufhebungsbestätigung</DownloadButton>
            <hr id="line"/>
            <section className="esc_box-shadow--small esc_border-radius--small" id="wrapper">
              <div className="ProductPicture">
                <img id="imageComputerSafety" src={process.env.PUBLIC_URL + "/statics/images/Computersicherheit.jpg"} alt=""/>
              </div>
              <div className="ProductContent">
                <h3>Sicherheits-Paket für Ihr Hab und Gut</h3>
                <p>Ob Brand, Wasserschaden oder Einbruchdiebstahl - schützen Sie sich vor den finanziellen Folgen mit einer günstigen Hausratversicherung.</p>
                <Button style={{ float: "right" }}><a id="policeDownloadLink" target="_blank" rel="noopener noreferrer" href="https://www.ergo.de/de/Produkte/Hausrat-und-Gebaeudeversicherung" class="esc_text-link">Mehr erfahren</a></Button>
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

export default WithdrawalDownload;
